import Tr from 'translations/Translations';

export const AgreementType = {
    SINGLE: "SINGLE",
    PUBLIC_FRAMEWORK: "PUBLIC_FRAMEWORK",
    SINGLE_EXECUTIVE: "SINGLE_EXECUTIVE"
}
const _TR_PREFIX = 'agreement_type_';

export const AgreementTypeLabel = (type) => (type ? Tr(_TR_PREFIX + type.toLowerCase()) : null);
